import React, { useContext } from 'react';
import RaisedButton from './RaisedButton';
import Context from '../../Context';
import VidNetClient from '../../API/VidNetClient';

const client = new VidNetClient();

const styles = {
  fontSize: '2rem',
  padding: '1rem',
  margin: '1rem',
};

const validInitials = (initials, videoSequences) => {
  const lengthCorrect = initials.length === 3;
  const unique = !videoSequences.some(object => object.Initials === initials);
  return lengthCorrect && unique && !initials.includes(' ');
};

export default function EnterButtonComponent(props) {
  const { initials } = props;

  const {
    narrative, setClips, setNarrative, videoSequences, setSequenceIndex, setVideoIndex,
  } = useContext(Context);

  const enterVideoSequence = () => {
    const newSequence = { Initials: initials, Sequence: narrative };
    videoSequences.unshift(newSequence);
    setClips(narrative);
    setNarrative([]);
    setSequenceIndex(0);
    setVideoIndex(0);
    client.postVideoSequence(newSequence);
  };

  return (
    <RaisedButton
      className="enter-button"
      onClick={() => enterVideoSequence()}
      hover="yellow"
      background="red"
      color="yellow"
      style={styles}
      disabled={!validInitials(initials, videoSequences)}
    >
      Enter
    </RaisedButton>

  );
}
